<div class="close icon-close" (click)="closeModal()"></div>
<div class="bloque-video">
    <div class="iphone-video">
        <video class="video-vimeo" loop muted playsinline autoplay oncanplay="this.play()" onloadedmetadata="this.muted=true">
            <source [src]="tutorial.urlVideoLoad | domSecurity" type="video/mp4">
        </video>
    </div>
    <img class="imagen-video" src="../../../assets/images/credomatic-miles/iphone-bac.png" alt="">
</div>